import React, { useState } from 'react';
import styles from './PriestPackageComponent.module.css';
import { deletePriestEventspackage } from '../../Apiservices/Auth/servers/fetchProviderData';

const PriestPackageView = ({ 
  packages = [], 
  onCreateNew,
  onEdit,
  onDelete,
  recommendedEvents
}) => {
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'active', 'inactive'
  const safePackages = Array.isArray(packages) ? packages : [];
   
const getEventNamesFromIds = (eventIds) => {
  if (!eventIds || !Array.isArray(eventIds)) return [];
  
  return eventIds
    .map(id => {
      // Find the event in recommendedEvents by id
      const event = recommendedEvents.find(e => e.id === id);
      return event ? event.name : null;
    })
    .filter(name => name !== null); // Remove null values
};
  
  // Filter packages based on active tab
  const filteredPackages = safePackages.filter(pkg => {
    if (activeTab === 'all') return true;
    if (activeTab === 'active') return pkg.isActive;
    if (activeTab === 'inactive') return !pkg.isActive;
    return true;
  });

  const handleDelete = async (packageId) => {
    if (window.confirm('Are you sure you want to delete this package?',packageId)) {
      try {
        const response = await deletePriestEventspackage(packageId);
        
        if (response && response.status === 200) {
          alert('Package deleted successfully!');
          if (onDelete) onDelete(packageId);
        } else {
          throw new Error(response?.data?.error || response?.data?.message || 'Failed to delete package');
        }
      } catch (error) {
        alert(error.message || 'An error occurred while deleting the package.');
      }
    }
  };

  return (
    <div className={styles.packageView}>
      <div className={styles.viewHeader}>
        <div className={styles.headerLeft}>
          <h2>Packages</h2>
          <p className={styles.viewSubtitle}>Manage your service packages</p>
        </div>
        <div className={styles.headerRight}>
          <button 
            className={styles.createButton}
            onClick={onCreateNew}
          >
            <i className="pi pi-plus"></i> Create New Package
          </button>
        </div>
      </div>


      {/* Packages Grid */}
      {packages.length === 0 ? (
        <div className={styles.noPackages}>
          <i className="pi pi-inbox" style={{ fontSize: '3rem', color: '#ccc', marginBottom: '1rem' }}></i>
          <h3>No packages found</h3>
          <p>Create your first package to bundle services together</p>
          <button 
            className={styles.createEmptyButton}
            onClick={onCreateNew}
          >
            Create New Package
          </button>
        </div>
      ) : (
        <div className={styles.packagesGrid}>
          {filteredPackages.map((pkg) => (
            <div 
              key={pkg.id} 
              className={`${styles.packageCard} ${!pkg.isActive ? styles.inactiveCard : ''}`}
            >
              <div className={styles.cardHeader}>
                <div className={styles.cardTitle}>
                  <h3>{pkg.name}</h3>
       
                </div>
                <div className={styles.cardActions}>
                  <button 
                    className={styles.actionButton}
                    onClick={() => onEdit(pkg)}
                    title="Edit"
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                  <button 
                    className={`${styles.actionButton} ${styles.deleteButton}`}
                    onClick={() => handleDelete(pkg.packageId)}
                    title="Delete"
                  >
                    <i className="pi pi-trash"></i>
                  </button>
                </div>
              </div>
              
              <div className={styles.cardBody}>
                <p className={styles.packageDescription}>
                  {pkg.description || 'No description provided'}
                </p>
                
                <div className={styles.packageStats}>
                  {/* <div className={styles.statItem}>
                    <span className={styles.statLabel}>Services:</span>
                    <span className={styles.statValue}>{pkg.servicesCount || 0}</span>
                  </div> */}
                  <div className={styles.statItem}>
                    <span className={styles.statLabel}>Priests:</span>
                    <span className={styles.statValue}>{pkg.numberOfPriests || 1}</span>
                  </div>
                  <div className={styles.statItem}>
                    <span className={styles.statLabel}>Price:</span>
                    <span className={styles.statValue}>
                      {pkg.offeredPrice ? `₹${pkg.offeredPrice}` : 'Not set'}
                      {pkg.price && pkg.price > pkg.offeredPrice && (
                        <span className={styles.originalPrice}>₹{pkg.price}</span>
                      )}
                    </span>
                  </div>
                  <div className={styles.statItem}>
                    <span className={styles.statLabel}>Valid Till:</span>
                    <span className={styles.statValue}>
                      {pkg.validTill ? new Date(pkg.validTill).toLocaleDateString() : 'N/A'}
                    </span>
                  </div>
                </div>

                {pkg.recommendedEvents && Array.isArray(pkg.recommendedEvents) && (
                  <div className={styles.recommendedEvents}>
                    <span className={styles.eventsLabel}>Recommended Events:</span>
                    <div className={styles.eventsList}>
                      {(pkg.recommendedEvents).map((event) => (
                        <span key={event.eventId} className={styles.eventTag}>
                          {event.eventName}
                        </span>
                      ))}
                      {(pkg.recommendedEvents).length === 0 && (
                        <span className={styles.noEvents}>No recommended events</span>
                      )}
                    </div>
                  </div>
                )}
              </div>
              
              <div className={styles.cardFooter}>
      
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PriestPackageView;